<div class="agreement">
  <div class="agreement__title" [innerHTML]="data.title"></div>
  <div class="agreement__description" [innerHTML]="data.description"></div>
</div>
